import { useState } from 'react';
import { useSession } from './session.js';

export const SessionControls = () => {
  const { csrfToken, logout, reauthenticate } = useSession();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const leave = async () => {
    if (busy) return;
    setBusy(true); setError(false);
    try { await logout(); } catch { setError(true); } finally { setBusy(false); }
  };
  return <section className="session-controls" aria-label="Sessão administrativa">
    {csrfToken === null ? <><p>Modo de consulta nesta aba. Entre novamente para liberar alterações.</p><button type="button" onClick={reauthenticate}>Entrar novamente</button></>
      : <button type="button" disabled={busy} onClick={() => void leave()}>{busy ? 'Encerrando…' : 'Sair'}</button>}
    {error ? <p role="alert">Não foi possível encerrar a sessão. Tente novamente ou <button type="button" onClick={reauthenticate}>autentique novamente</button>.</p> : null}
  </section>;
};
